import { apiSlice } from '../../app/services/apiSlice';
import { MeetingOptions } from './assets/utills';

const INTERVIEW_URL = 'interviews';
const CALENDAR_URL = 'calendar';
export const InterviewSliceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInterviewReminderConfig: builder.query({
      query: (params) => ({
        url: `interviews/reminder`,
        params,
      })
    }),
    addSlots: builder.mutation({
      query: (data) => ({
        url: `${INTERVIEW_URL}/slot`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    getOptionType: builder.query({
      query: (params) => ({
        url: `${CALENDAR_URL}/providers/connected`,
        params,
      }),
      transformResponse: (responseData) => {
        let typeOptions = [MeetingOptions[0]]
        const accountAcess = responseData?.message?.map(item => item?.provider?.accessKey)
        MeetingOptions.map(item => accountAcess.includes(item?.label?.accessKey) ? typeOptions.push(item) : item)
        return typeOptions;
      },
    }),

    getOptionTypes: builder.mutation({
      query: (params) => ({
        url: `${CALENDAR_URL}/providers/connected`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = (() => {
          if (responseData?.googleConnected?.length > 0 && responseData?.outlookConnected?.length > 0) {
            return MeetingOptions.map(item => item);
          } else if (responseData?.googleConnected?.length > 0) {
            return MeetingOptions.filter(item => item.value !== 3);
          } else if (responseData?.outlookConnected?.length > 0) {
            return MeetingOptions.filter(item => item.value !== 2);
          } else {
            return [MeetingOptions[0]];
          }
        })();

        return responseData;
      },
    }),

    updateSlots: builder.mutation({
      query: (data) => ({
        url: `${INTERVIEW_URL}/slot/${data.id}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    getAllSlots: builder.mutation({
      query: (params) => ({
        url: `${INTERVIEW_URL}/slots`,
        method: 'GET',
        params: params
      }),
      // transformResponse: (responseData) => {
      //   responseData = responseData?.slots
      //   return responseData || [];
      // },
    }),
    removeSlots: builder.mutation({
      query: (params) => ({
        url: `${INTERVIEW_URL}/slot/${params.id}`,
        method: 'DELETE',
        // params,
      }),
    }),

    sendInvitaions: builder.mutation({
      query: (data) => ({
        url: `${INTERVIEW_URL}/invitation`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    sendSmsInvitaton: builder.mutation({
      query: (data) => ({
        url: `applications/sms`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    getAllSelfSlots: builder.mutation({
      query: (params) => ({
        url: `${INTERVIEW_URL}/slots`,
        method: 'GET',
        params: params
      }),
    }),
    addInterviewSlot: builder.mutation({
      query: (data) => ({
        url: `${INTERVIEW_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    preSignedAttachmentInterviewUrl: builder.mutation({
      query: (data) => ({
        url: `${INTERVIEW_URL}/slot/preSignedMailAttachment`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    interviewConfig: builder.mutation({
      query: (data) => ({
        url: `interviews/reminder`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateInterviewConfig: builder.mutation({
      query: (data) => ({
        url: `interviews/reminder/${data.id}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),

    getInterviewstimeSlots: builder.mutation({
      query: (params) => ({
        url: `${INTERVIEW_URL}/slot`,
        method: 'GET',
        params: params
      }),
      transformResponse: (responseData) => {
        responseData = responseData?.slots
        return responseData || [];
      },
    }),
  }),
});

export const {
  useUpdateInterviewConfigMutation,
  useInterviewConfigMutation,
  useGetInterviewReminderConfigQuery,
  useGetAllSelfSlotsMutation,
  useGetAllSlotsMutation,
  useAddSlotsMutation,
  useSendInvitaionsMutation,
  useSendSmsInvitatonMutation,
  useRemoveSlotsMutation,
  useUpdateSlotsMutation,
  useAddInterviewSlotMutation,
  useGetOptionTypeQuery,
  useGetOptionTypesMutation,
  usePreSignedAttachmentInterviewUrlMutation,
  useGetAllInterviewsSlotsMutation,
} = InterviewSliceApi;
